module.exports = __webpack_public_path__ + "static/alva-7330fa2e2cd6076a386d492b90553355.png";